export const TERRAFORM_S3_BUCKET = "terraform.cnoe.io/s3-bucket"
export const TERRAFORM_S3_PREFIX = "terraform.cnoe.io/s3-prefix"
export const TERRAFORM_LOCAL_PATH = "terraform.cnoe.io/local-filepath"
export const TERRAFORM_SECRET_NAME = "terraform.cnoe.io/secret-name"
export const TERRAFORM_SECRET_NAMESPACE = "terraform.cnoe.io/secret-namespace"